import { AthleticUser } from './athletic-user.interface';

export class AnonymousModel implements AthleticUser {
  userId = 0;
  isAdmin = false;
  hasSS = false;
  isCoach = false;
  managedAthleteIds = [];
  userEditToken = '';
  userVerifyToken = '';
}
